import { render, staticRenderFns } from "./addGravyTransfer.vue?vue&type=template&id=1ebbb3ea"
import script from "./addGravyTransfer.vue?vue&type=script&lang=js"
export * from "./addGravyTransfer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports